module.exports = __webpack_public_path__ + "static/media/aepe.9d68a30f.jpg";